import { Link } from '@chakra-ui/next-js';
import { HStack, Icon, Stack, Text } from '@chakra-ui/react';
import { TbMailFilled, TbMapPinFilled, TbPhoneFilled } from 'react-icons/tb';

interface ContactDetailsProps {
  phone?: string | null;
  email?: string | null;
  location?: string | null;
  locationHref?: string | null;
  centered?: boolean;
  size?: 'xs' | 'sm' | 'md' | 'lg';
  compact?: boolean;
}

export const ContactDetails = ({
  phone,
  email,
  location,
  locationHref,
  size = 'sm',
}: ContactDetailsProps) => {
  return (
    <Stack
      gap="2"
      onClick={(e) => {
        e.stopPropagation();
      }}
    >
      {location && (
        <HStack color="blackAlpha.700" gap="1">
          <Icon as={TbMapPinFilled} boxSize="14px" />
          <Text size={size} fontWeight="light">
            {locationHref ? (
              <Link
                title={location}
                onClick={(e) => e.stopPropagation()}
                href={locationHref}
              >
                {location}
              </Link>
            ) : (
              location
            )}
          </Text>
        </HStack>
      )}

      {phone && (
        <HStack color="blackAlpha.700" gap="1">
          <Icon as={TbPhoneFilled} boxSize="14px" />
          <Text fontSize={size} fontWeight="light">
            <Link
              title={`Ring ${phone}`}
              onClick={(e) => e.stopPropagation()}
              href={`tel:${phone}`}
            >
              {phone}
            </Link>
          </Text>
        </HStack>
      )}

      {email && (
        <HStack color="blackAlpha.700" gap="1">
          <Icon as={TbMailFilled} boxSize="14px" />
          <Text fontSize={size} fontWeight="light">
            <Link
              title={`Maila ${email}`}
              onClick={(e) => e.stopPropagation()}
              href={`mailto:${email}`}
            >
              {email}
            </Link>
          </Text>
        </HStack>
      )}
    </Stack>
  );
};
